[
  { "id": "anselme", "name": "Anselme — conteur", "render": { "engine": "supertonic", "voice": "M5" } },
  { "id": "armand", "name": "Armand — grave", "render": { "engine": "supertonic", "voice": "M2" } },
  { "id": "lucien", "name": "Lucien — enjoué", "render": { "engine": "supertonic", "voice": "M1" } },
  { "id": "basile", "name": "Basile — juvénile", "render": { "engine": "supertonic", "voice": "M4" } },
  { "id": "helene", "name": "Hélène — posée", "render": { "engine": "supertonic", "voice": "F1" } },
  { "id": "apolline", "name": "Apolline — douce", "render": { "engine": "supertonic", "voice": "F5" } },
  { "id": "lison", "name": "Lison — pétillante", "render": { "engine": "supertonic", "voice": "F2" } },
  { "id": "jeanne", "name": "Jeanne — comédienne", "render": { "engine": "kokoro", "voice": "ff_siwis", "speed": 0.9 } }
]
